import * as React from "react";
import {useNavigate} from "react-router-dom";
import TopNavigation from "@cloudscape-design/components/top-navigation";
import UserService from "../../services/UserService";
import { useUserContext } from "contexts/UserContext";
import AppConfig from "configs/AppConfig";
import PERMISSIONS from "configs/Permissions";

const TopNavigationPanel: React.FC = () => {
  const { firstName, lastName, email } = useUserContext();
  const isAdmin = UserService.hasRole([PERMISSIONS.ADMINISTRATION.ADMINISTRATOR_ROLE]);
  const navigate = useNavigate();

  const handleSignOutClick = () => {
    UserService.doLogout();
  };

  const handleUtilityItemClick = (id: string) => {
    switch (id) {
      case "signout":
        handleSignOutClick();
        break;
      case "account-settings":
        navigate("/account-settings");
        break;
      case "administration":
        break;
      case "organizations":
        navigate("/organizations");
        break;
      // Add additional cases for other item actions if needed
      default:
        console.log(`Unhandled utility item: ${id}`);
    }
  };

  return (
    <TopNavigation
      identity={{
        href: "/",
        logo: {
          src: `${process.env.PUBLIC_URL}/assets/logo-light.png`,
          alt: "Aswar Logo",
        },
      }}
      utilities={[
        {
          type: "menu-dropdown",
          iconName: "notification",
          title: "Notifications",
          ariaLabel: "Notifications (unread)",
          disableUtilityCollapse: false,
          items: [
            {
              id: "no-notifications",
              text: "No notification to display",
            },
          ],
        }
        ,
        /* {
          type: "menu-dropdown",
          iconName: "settings",
          ariaLabel: "Settings",
          title: "Settings",
          items: [
            {
              id: "settings-org",
              text: "Organizational settings",
            },
            {
              id: "settings-project",
              text: "Project settings",
            },
          ],
        }, */
        {
          type: "menu-dropdown",
          text: firstName + " " + lastName,
          description: email,
          iconName: "user-profile",
          onItemClick: (event) => handleUtilityItemClick(event.detail.id),
          items: [
            { id: "account-settings", text: "Account Settings" },
            { id: "organizations", text: "Organizations" },
            ...(isAdmin ? [
              { id: "administration", text: "Aswar Administration", href: AppConfig.ASWAR_ADMINISTRATION_URL, external: true },
            ]:[]),
            { id: "signout", text: "Sign out" },
          ],
        },
      ]}
    />
  );
};

export default TopNavigationPanel;
